module.exports = __webpack_public_path__ + "static/media/32.b044c55b.jpg";